<template>

  <div class="container">
    <!-- XOL-392: self-profile is NOT contact administration. `self-profile`
         suppresses the System Details and Remarks tabs and moves the password
         control onto the one remaining tab. -->
    <contact-detail :row-data="profile()" prefix="User Profile" :parent-managed="true" :self-profile="true" />
  </div>

</template>

<script>

import ContactDetail from '@/components/tables/details/ContactDetail'

export default {
  components: {
    ContactDetail
  }
}

</script>
